import { createSlice } from "@reduxjs/toolkit";
import { getAllBanks } from "../../builders/MasterConfig/master.config.builder";
import { createDesignation, editDesignation, getDesignation } from "../../builders/MasterConfig/master.config.builder";

const initialState = {
    banks: [],
    designation: [],
    loading : false,
};

const inquirySource = createSlice({
    name: "masterConfig",
    initialState,
    reducers: {

        clearExtraReducers: (state) => {
            state.inquirySourceData = []
            state.banks = []
            state.loading = false
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getAllBanks.pending, (state) => {
            state.loading = true
        });
        builder.addCase(getAllBanks.fulfilled, (state, action) => {
            state.loading = false
            state.banks = action.payload
        });
        builder.addCase(getAllBanks.rejected, (state) => {
            state.loading = false
        });

        builder.addCase(getDesignation.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(getDesignation.fulfilled, (state, action) => {
            state.loading = false
            state.designation = action.payload
        })
        builder.addCase(getDesignation.rejected, (state, action) => {
            state.loading = false
        })

        builder.addCase(createDesignation.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(createDesignation.fulfilled, (state, action) => {
            state.loading = false
        })
        builder.addCase(createDesignation.rejected, (state, action) => {
            state.loading = false
        })

        builder.addCase(editDesignation.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(editDesignation.fulfilled, (state, action) => {
            state.loading = false
        })
        builder.addCase(editDesignation.rejected, (state, action) => {
            state.loading = false
        })
        

        // builder.addCase(createInquirySource.pending, (state, action) => {
        //     state.loading = true
        // });
        // builder.addCase(createInquirySource.fulfilled, (state, action) => {
        //     state.loading = false
        // });
        // builder.addCase(createInquirySource.rejected, (state, action) => {
        //     state.loading = false
        // });

        // builder.addCase(editInquirySource.pending, (state, action) => {
        //     state.loading = true
        // });
        // builder.addCase(editInquirySource.fulfilled, (state, action) => {
        //     state.loading = false
        // });
        // builder.addCase(editInquirySource.rejected, (state, action) => {
        //     state.loading = false
        // });


    },
});

// export const { } = followupSlice.actions;

export default inquirySource.reducer;
